import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import Link from 'next/link';
import parse from 'html-react-parser';
import styles from './tableOfContents.module.scss';

export default function TableOfContents({
  title = 'Table of Contents',
  items = [],
  offset = 0,
  onClick,
}) {
  const [isdropdownActive, setIsDropdownActive] = useState(false);
  const [dropdownActiveSub, setDropdownActiveSub] = useState(null);
  const [headerHeight, setHeaderHeight] = useState(null);

  useEffect(() => {
    const mainHeaderHeight =
      document.getElementsByTagName('header') != null &&
      document.getElementsByTagName('header').length > 0
        ? document.getElementsByTagName('header')[0].clientHeight
        : 72;
    setHeaderHeight(mainHeaderHeight);
  }, []);

  useEffect(() => {
    const onScroll = () => {
      let activeSubIndex = null;
      items.forEach((item, index) => {
        const offsetTop =
          document.getElementById(item.link.substring(1)).offsetTop -
          headerHeight +
          48;
        if (window.pageYOffset >= offsetTop) {
          activeSubIndex = index;
        }
      });
      setIsDropdownActive(true);
      setDropdownActiveSub(activeSubIndex);
    };
    window.removeEventListener('scroll', onScroll);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [items, offset, headerHeight]);

  const handleDropdownClick = (e, index, link) => {
    onClick(index);
    if (link.startsWith('#')) {
      e.preventDefault();
      const id = link.substring(1);
      if (document.getElementById(id) != null) {
        const postThumbnailHeigh =
          document.getElementById('postThumbnail') != null
            ? document.getElementById('postThumbnail').clientHeight
            : 0;
        window.scrollTo({
          behavior: 'smooth',
          top:
            document.getElementById(id).offsetTop -
            headerHeight +
            (postThumbnailHeigh + 48),
        });
      }
    }
  };
  return items && items?.length ? (
    <div className={styles.wrapper}>
      <div className={styles.title}>
        <h3
          itemType="https://schema.org/alternativeHeadline"
          itemProp="alternativeHeadline"
        >
          {title}
        </h3>
      </div>
      <nav className={styles.dropdownMenu}>
        <ul>
          {items?.map((menu, index) => (
            <li
              key={`${menu.link}`}
              className={`${styles.dropdownItem} ${
                dropdownActiveSub === index && isdropdownActive && styles.active
              }`}
            >
              <Link
                href={`${menu?.link}`}
                data-testid={menu.link.startsWith('#') ? '' : menu.link}
                onClick={(e) => handleDropdownClick(e, index, menu.link)}
              >
                {parse(menu?.label)}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  ) : null;
}

TableOfContents.propTypes = {
  title: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      link: PropTypes.string,
    })
  ),
  offset: PropTypes.number,
};
